import { create } from "zustand";

type SmsRefreshState = {
  versionByLead: Record<number, number>;
  bump: (leadId: number) => void;
};

// A messaging socket event (a lead's inbound text, a delivery status) bumps the
// lead's version; every mounted SMS surface for that lead — the thread popup,
// the Interactions tab, the conversation history — refetches instead of going
// stale until reopened.
export const useSmsRefreshStore = create<SmsRefreshState>()((set) => ({
  versionByLead: {},
  bump: (leadId) =>
    set((state) => ({
      versionByLead: { ...state.versionByLead, [leadId]: (state.versionByLead[leadId] ?? 0) + 1 },
    })),
}));
